import { createRoot } from "react-dom/client";

import { QuickBooksApp } from "./quickbooks-app";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("QuickBooks root element is missing.");

createRoot(root).render(<QuickBooksApp />);
